
import { defineComponent, computed } from "vue";
import store from "@/store";
import DateUtils from "@/utils/DateUtils";
import stateStore from "@/utils/store";

export default defineComponent({
    name: "UserAuditInfo",
    props: {
        item: {
            type: Object,
            required: true,
        },
        mode: {
            type: String,
            required: true,
        },
    },
    setup() {
        const stateStoreInstance = stateStore;
        const users = computed(() => store.getters["auth/systemUsers"]);
        return {
            users,
            stateStoreInstance,
        };
    },


    methods: {
        getUserNameById(userId: number): string {
            const user = this.users.find((u: any) => u.Id === userId);
            return user ? `${user.FirstName} ${user.LastName}`.trim() : "";
        },

        getCreatedBy(): string {
            return this.getUserNameById(this.item.CreatedBy);
        },
        getModifiedBy(): string {
            return this.getUserNameById(this.item.ModifiedBy);
        },
        formatDate(date: any): string {
            return DateUtils.formatDateTime(date);
        },
    },
});
